import { render, staticRenderFns } from "./JobsOverview.vue?vue&type=template&id=199bf539&scoped=true&"
import script from "./JobsOverview.vue?vue&type=script&lang=js&"
export * from "./JobsOverview.vue?vue&type=script&lang=js&"
import style0 from "./JobsOverview.vue?vue&type=style&index=0&id=199bf539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199bf539",
  null
  
)

export default component.exports